import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Sidebar.css";

const StoryTreePagesideber = ({ currentNode, nodes, storyId, className }) => {
  const navigate = useNavigate();

  /** クリックノードからルートまでの本文を構築 */
  const buildContentFromParent = useCallback(
    (clickedNode) => {
      if (!clickedNode) return "";

      const contentArray = [];
      const traversedNodes = [];

      let node = nodes.find((n) => n.id === clickedNode.id) || clickedNode;

      while (node) {
        const text = node.text || node.content;
        if (text) {
          contentArray.unshift(text);
          traversedNodes.unshift(text);
        }

        if (!node.parentId) break;

        const nextNodeId = node.parentId;
        node = nodes.find((n) => n.id === nextNodeId);
      }

      console.log("クリックノードからルートまで辿ったノード:", traversedNodes);
      return contentArray.join("\n");
    },
    [nodes]
  );

  const content = currentNode ? buildContentFromParent(currentNode) : "";

  /** 再開ボタンクリック */
  const handleResume = () => {
    if (!currentNode) return alert("再開するノードが選択されていません。");

    const fullNodeData = nodes.find((n) => n.id === currentNode.id) || {};

    const resumeState = {
      parentId: fullNodeData.id || currentNode.id,
      storyId,
      previousContent: content,
      category: fullNodeData.category || "その他",
      title: fullNodeData.title || "",
      threadType: fullNodeData.threadType || "story",
      voteMethod: fullNodeData.voteMethod || "author",
      voteTime: fullNodeData.voteTime || 1,
      firstNodeId: fullNodeData.id,
      parentNodeId: fullNodeData.id,
    };

    console.log("再開ボタン押下時に渡す state:", resumeState);

    navigate("/create", { state: resumeState });
  };

  return (
    <div className={`chat-sidebar ${className || ""}`}>
   
      <div className="sidebar-section">
     
        <h3>クリックした場所までの本文</h3>
        <p>
          {content
            ? content.split("\n").map((text, idx) => (
                <React.Fragment key={idx}>
                  {text} <br />
                </React.Fragment>
              ))
            : "本文がありません"}
        </p>
      </div>
      {currentNode && (
        <div className="sidebar-actions">
          <button className="resume-btn" onClick={handleResume}>
            🌱 この場所から再開
          </button>
        </div>
      )}
    </div>
  );
};

export default StoryTreePagesideber;
